import styled from "styled-components";
import * as Styles from "../../../../../common-deprecated/features/filters/styles/TopFiltersStyles";

export const Filters = styled(Styles.Filters)`
    align-items: end;
`;
